import type { IconSvgObject } from './types';

const ListStartIcon: IconSvgObject = [
  ["path", { d: "M3 6H9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16 9C16 9 13 6.79053 13 5.99998C13 5.20942 16 3 16 3M14 6L15 6C17.8284 5.99999 19.2426 5.99998 20.1213 6.87866C21 7.75734 21 9.17156 21 12V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 13H16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M3 20H16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default ListStartIcon;
